import React from 'react';
import styled, { keyframes } from 'styled-components';
import { size2, size4, size8, size12, size16, size24 } from '../theme/scale';
import { gray300, gray400, primary400, primary100 } from '../theme/colors';
export const LOADER_SIZES = {
  xs: {
    dot: size4,
    margin: size2
  },
  sm: {
    dot: size8,
    margin: size4
  },
  md: {
    dot: size16,
    margin: size8
  },
  lg: {
    dot: size24,
    margin: size12
  }
};
const dotAnimation = color => keyframes`
  0%, 80%, 100% {
    background: ${color === 'gray' ? gray300 : primary100};
    transform: scale(.9);
  } 40% {
    background: ${color === 'gray' ? gray400 : primary400};
    transform: scale(1);
  }
`;
const LoaderContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
`;
const LoaderDot = styled.div`
  width: ${({
  size: {
    dot
  }
}) => dot};
  height: ${({
  size: {
    dot
  }
}) => dot};
  border-radius: 100%;
  animation: ${({
  color
}) => dotAnimation(color)} 1400ms infinite ease-in-out
    both;

  &:not(:last-of-type) {
    margin-right: ${({
  size: {
    margin
  }
}) => margin};
  }

  &:nth-child(1) {
    animation-delay: -320ms;
  }

  &:nth-child(2) {
    animation-delay: -160ms;
  }
`;
export const Loader = ({
  size = 'sm',
  color = 'gray',
  ariaLabel
}) => /*#__PURE__*/React.createElement(LoaderContainer, {
  role: "alert",
  "aria-label": ariaLabel,
  "aria-busy": "true",
  "data-testid": "loader"
}, /*#__PURE__*/React.createElement(LoaderDot, {
  color: color,
  size: LOADER_SIZES[size]
}), /*#__PURE__*/React.createElement(LoaderDot, {
  color: color,
  size: LOADER_SIZES[size]
}), /*#__PURE__*/React.createElement(LoaderDot, {
  color: color,
  size: LOADER_SIZES[size]
}));
export default Loader;
//# sourceMappingURL=index.js.map